import styled from "styled-components";

export const SignUpBlock = styled.div`
  width: 380px;
  display: flex;
  flex-direction: column;
`;
